export const DATEFORMAT = 'YYYY-MM-DD';
export const DATEFORMAT_WHOLE = 'YYYY-MM-DD HH:mm:ss';
export const DATEFORMAT_MINUTE = 'YYYY-MM-DD HH:mm';

// 流程类型
export const PROCESS_TYPE = {
  PRODUCE: {
    value: 1,
    text: '生产',
  },
  REVIEW: {
    value: 2,
    text: '质检',
  },
  CHECK: {
    value: 3,
    text: '验收',
  },
  RECEIPT: {
    value: 4,
    text: '入库',
  },
  ANNOTATION: {
    value: 5,
    text: '标注',
  },
};

// 自定义字段类型
export const CUSTOMIZE_FIELD_TYPE = {
  TEXT: {
    value: 1,
    text: '文本',
    alias: 'text',
  },
  NUMBER: {
    value: 2,
    text: '数字',
    alias: 'number',
  },
  SELECT: {
    value: 3,
    text: '选项',
    alias: 'select',
  },
  USER: {
    value: 4,
    text: '人员',
    alias: 'user',
  },
  TIME: {
    value: 5,
    text: '时间',
    alias: 'time',
  },
  IMAGE: {
    value: 6,
    text: '图片',
    alias: 'image',
  },
  FORMULA: {
    value: 7,
    text: '公式',
    alias: 'formula',
  },
  INTERFACE: {
    value: 8,
    text: '接口',
    alias: 'interface',
  },
  TEMPLATE_STR: {
    value: 9,
    text: '模板字符串',
    alias: 'template_str',
  },
} as const;

// 选项类型
export const FILTER_TYPE = {
  SINGLE: {
    value: 1,
    text: '单选',
  },
  MULTIPLE: {
    value: 2,
    text: '多选',
  },
};

// 状态
export const STATUS_TYPE = {
  OFF: {
    value: 0,
    text: '禁用',
  },
  ON: {
    value: 1,
    text: '启用',
  },
};

// 任务类型 - 新流程
export const TASK_STATUS_UPGRADED = {
  PRODUCE: {
    value: 1,
    text: '未入库',
  },
  RECEIPT: {
    value: 4,
    text: '入库',
  },
};

// 主题颜色
export enum ThemeMap {
  Light = 'light', // 普通模式
  Protect = 'protect', // 护眼模式
}

// 基本状态
export const BASE_STATUS_TYPE = {
  NO: {
    value: 0,
    label: '否',
  },

  YES: {
    value: 1,
    label: '是',
  },
};

// 行高是否固定
export enum IsFixedRowHeight {
  Fixed = 'fix-max-height', // 固定行高
  Auto = ' ', // 默认auto
}

// 公式类型
export const FORMULA_TYPE = {
  NOT_NULL: {
    value: 1,
    text: '必填约束',
  },
};

// 接口映射
export const CORPUS_INTERFACE_MAP = {
  RAG: {
    value: 1,
    url: '/api/corpusUpgraded/getRagResult',
    text: 'RAG填充',
  },
  GEN_IMG: {
    value: 2,
    url: '/api/corpusUpgraded/postGenerateImg',
    text: '生图调试',
  },
  GEN_MODEL_RESPONSE: {
    value: 3,
    url: '/api/interface/getLLMResult',
    text: '通用模型',
  },
};

// 评估任务类型
export const EVAL_TASK_TYPE_MAP = {
  TTS_BLIND: {
    value: 1,
    label: 'TTS盲评',
  },
  TTS_COMPARED: {
    value: 2,
    label: 'TTS对比评估',
  },
  IMG: {
    value: 3,
    label: '图片模型横评',
  },
};

export const TEMPLATE_TYPE = {
  TEXT: {
    value: 1,
    label: '文本',
  },
  IMAGE: {
    value: 2,
    label: '图片',
  },
};

export enum GeneralModelType {
  LLM = 1,
  IMG = 2,
}

export const GENERAL_MODEL_LIST = {
  GPT5: {
    key: 'gpt-5',
    value: 'gpt-5',
    label: 'GPT-5',
    type: GeneralModelType.LLM,
  },
  GPT4o: {
    key: 'gpt-4o',
    value: 'gpt-4o',
    label: 'GPT-4o',
    type: GeneralModelType.LLM,
  },
  JIMENG: {
    key: 'JIMENG',
    value: 'JIMENG',
    label: '即梦',
    type: GeneralModelType.IMG,
  },
};
